// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\n.widget-buttons-container{\n  position:absolute !important;\n  right: 10px;\n  top: 3px;  \n}\n\n.widget-button{\n  margin:0 !important;\n  width:18px !important;\n  height:18px !important;\n}\n\n.widget-button-icon\n{\n  width:16px !important;\n  height:16px !important;\n}\n\n\n/* Borders */\n\n.widget-border-line {\n  border-style: solid;\n  border-width: 1px;\n  border-color: black;\n}\n", ""]);
// Exports
module.exports = exports;
